














import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import ImageView from '@/atoms/ImageView.vue';
import { Product } from '@/models/Product';


@Component({
	components: { ImageView }
})
export default class ProductComponent extends Vue {

	@Prop()
	product?: Product;

	get item(): Product | undefined {
		return this.product;
	}

	zoomClick(item: Product): void {
		this.$emit('zoom-click', item);
	}
}
